import { IntlTFunc } from 'next-intl';

import { ProductAttributeSortInput, SortField } from '@/fo/api/magento';

import { FilterOption } from './types';

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export const SORT_OPTIONS_MAP: Record<
  string,
  {
    direction: keyof typeof SORT_DIRECTION;
    value: keyof ProductAttributeSortInput;
  }
> = {
  priceAsc: {
    direction: SORT_DIRECTION.ASC,
    value: 'price'
  },
  priceDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'price'
  },
  positionDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'position'
  },
  discountDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'discount_percent'
  },
  priceNewDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'new'
  },
  popularityDesc: {
    direction: SORT_DIRECTION.DESC,
    value: 'popularity'
  }
};

export const SORT_OPTIONS = (t: IntlTFunc): (SortField & FilterOption)[] => [
  {
    value: 'popularityDesc',
    label: t('sortOptions.popularity')
  },
  {
    value: 'priceNewDesc',
    label: t('sortOptions.news')
  },
  {
    value: 'priceAsc',
    label: t('sortOptions.priceAsc')
  },
  {
    value: 'priceDesc',
    label: t('sortOptions.priceDesc')
  },
  {
    value: 'discountDesc',
    label: t('sortOptions.discount')
  }
];

export const DEFAULT_SORT_OPTION = SORT_OPTIONS_MAP.popularityDesc;
